export const ON_FETCH_DATA = "ON_FETCH_DATA"
export const ON_FETCH_DATA_SUCCESS = "ON_FETCH_DATA_SUCCESS"
export const ON_FETCH_DATA_FAILED = "ON_FETCH_DATA_FAILED"
export const ON_USER_ACTIVE = "ON_USER_ACTIVE"
export const ON_CHANGE_TRAIN_ACTION = "ON_CHANGE_TRAIN_ACTION"

export const ON_INCREMENT_SCORE="ON_INCREMENT_SCORE"
export const ON_TOGGLE_SHOE="ON_TOGGLE_SHOE"
export const ON_CHANGE_SHOE_TYPE="ON_CHANGE_SHOE_TYPE"